import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { OrderSuccess } from "@/components/store/OrderSuccess";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [state, setState] = useState("verifying"); // verifying | success | failed
  const [order, setOrder] = useState(null);
  const reference = params.get("reference") || params.get("trxref");

  useEffect(() => {
    if (!reference) {
      setState("failed");
      return;
    }
    api
      .get(`/payments/verify/${reference}`)
      .then((r) => {
        if (r.data.status === "success") {
          clear();
          setOrder(r.data.order);
          setState("success");
        } else {
          setState("failed");
        }
      })
      .catch(() => setState("failed"));
  }, [reference]);

  if (state === "verifying")
    return (
      <div className="pt-40 pb-24 text-center min-h-screen" data-testid="payment-verifying">
        <div className="w-10 h-10 border-2 border-terracotta border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-bark">Verifying your payment…</p>
      </div>
    );

  if (state === "success" && order) return <OrderSuccess order={order} />;

  return (
    <div className="pt-40 pb-24 text-center min-h-screen" data-testid="payment-failed">
      <h1 className="font-serif text-4xl text-espresso mb-4">Payment not completed</h1>
      <p className="text-bark mb-6">We couldn&apos;t confirm your payment. Please try again.</p>
      <Link to="/checkout" className="text-terracotta underline">Return to checkout</Link>
    </div>
  );
}
